import React from 'react';
import { useTranslate } from 'react-admin';
import { ListItem, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  listLabel: {
    fontWeight: '500',
    color: '#637381',
    width: '30%'
  },
  listValue:{
    width:'70%'
  },
  listItem: {
    marginBottom: 12,
    padding: 0
  },
}));

const TireSize = ({ vehicle }) => {
  const classes = useStyles();
  const translate = useTranslate();

  if (!vehicle) return null;

  const {
    selected_tire_size,
    technician_verified_tire_size,
    standard_tire_sizes,
  } = vehicle;

  const doBothSizesExist =
    !!selected_tire_size && !!technician_verified_tire_size;
  const areBothSizesEqual =
    selected_tire_size === technician_verified_tire_size;

  // If there is no customer selected and no technician verified tire size,
  // show the standard tire sizes with a single label
  if (!selected_tire_size && !technician_verified_tire_size) {
    return (
      !!standard_tire_sizes?.length && (
        <ListItem className={classes.listItem}>
          <span className={classes.listLabel}>
            {translate('resources.vehicle.fields.tire_size')}:&nbsp;
          </span>
          <span className={classes.listValue}>{standard_tire_sizes?.join(', ')}</span>
        </ListItem>
      )
    );
  }
  // If customer selected and technician verified tire size exist and are both equal
  // OR only one of the values exists, show 1 tire size value with 1 label
  if ((doBothSizesExist && areBothSizesEqual) || !doBothSizesExist) {
    return (
      <ListItem className={classes.listItem}>
        <span className={classes.listLabel}>
          {translate('resources.vehicle.fields.tire_size')}:&nbsp;
        </span>
        <span className={classes.listValue}>{selected_tire_size || technician_verified_tire_size}</span>
      </ListItem>
    );
  }

  // If both tire sizes exist but are not equal, show both with seperate labels
  return (
    <>
      <ListItem className={classes.listItem}>
        <span className={classes.listLabel}>
          {translate('resources.vehicle.fields.selected_tire_size')}
          :&nbsp;
        </span>
        <span className={classes.listValue}>{selected_tire_size}</span>
      </ListItem>
      <ListItem className={classes.listItem}>
        <span className={classes.listLabel}>
          {translate('resources.vehicle.fields.technician_verified_tire_size')}
          :&nbsp;
        </span>
        <span className={classes.listValue}>{technician_verified_tire_size}</span>
      </ListItem>
    </>
  );
};

export default TireSize;
